module.exports = __webpack_public_path__ + "img/befundung_der_gelenke.075718b6.jpg";